import {
  BookActionEnum,
  IAssociateBookWithDocIdAction,
  IAssociateBookWithDocIdFailureAction,
  IAssociateBookWithDocIdSuccessAction,
  IClearBookResultAction,
  IFetchBookAction,
  IFetchBookByDocIdsAction,
  IFetchBookByDocIdsFailureAction,
  IFetchBookByDocIdsSuccessAction,
  IFetchBookFailedAction,
  IFetchBookSuccessAction,
} from '.';
import {
  IBook,
  IDocumentBookCode,
  IUpdateDocumentBookCodeResult,
} from '../../services';

export const FetchBookAction = () => {
  return {
    type: BookActionEnum.FetchBooks,
    state: { loading: true },
  } as IFetchBookAction;
};

export const FetchBookSuccessAction = (books: IBook[]) => {
  return {
    type: BookActionEnum.FetchBookSuccess,
    state: { loading: false, books: books },
  } as IFetchBookSuccessAction;
};

export const FetchBookFailedAction = () => {
  return {
    type: BookActionEnum.FetchBookFailed,
    state: { loading: false },
  } as IFetchBookFailedAction;
};

export const FetchBookWithDocIdByDocIdAction = (docId: string) => {
  return {
    type: BookActionEnum.FetchBookWithDocIdsByDocIds,
    state: { loading: true, bookAndDocId: { docId: docId } },
  } as IFetchBookByDocIdsAction;
};

export const FetchBookWithDocIdByDocIdSuccessAction = (
  bookAndDocId: IDocumentBookCode
) => {
  return {
    type: BookActionEnum.FetchBookWithDocIdsByDocIdsSuccess,
    state: { loading: false, bookAndDocId },
  } as IFetchBookByDocIdsSuccessAction;
};

export const FetchBookWithDocIdByDocIdFailureAction = (message: string) => {
  return {
    type: BookActionEnum.FetchBookWithDocIdsByDocIdsFailure,
    state: { loading: false, message: message },
  } as IFetchBookByDocIdsFailureAction;
};

export const AssociateBookWithDocIdAction = (
  documentBookCode: IDocumentBookCode
) => {
  return {
    type: BookActionEnum.AssociateBookWithDocId,
    state: {
      loading: true,
      bookAndDocId: documentBookCode,
      corridorCode: documentBookCode.corridorCode,
    },
  } as IAssociateBookWithDocIdAction;
};

export const AssociateBookWithDocIdSuccessAction = (
  response: IUpdateDocumentBookCodeResult
) => {
  return {
    type: BookActionEnum.AssociateBookWithDocIdSuccess,
    state: {
      loading: false,
      updateDocumentBookCodeResult: response,
      bookAndDocId: response.documentBookCode,
    },
  } as IAssociateBookWithDocIdSuccessAction;
};

export const AssociateBookWithDocIdFailureAction = (message: string) => {
  return {
    type: BookActionEnum.AssociateBookWithDocIdFailure,
    state: { loading: false, exceptionMessage: message },
  } as IAssociateBookWithDocIdFailureAction;
};

export const ClearBookResult = () => {
  return {
    type: BookActionEnum.ClearBookResult,
    state: { updateDocumentBookCodeResult: {} as IUpdateDocumentBookCodeResult },
  } as IClearBookResultAction;
};
